import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import ProfileOrderHistorySection from '/component/partial/profile/ProfileOrderHistorySection';
import {withTranslation} from '/provider/TranslationProvider';
import {profileOrdersById} from '/redux/selector/client.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {withHOC} from '/util/hoc.util';
import {fromProps, withProps} from '/util/selector.util';

const withClientId = withProps({
  clientId: fromProps(get('coachId')),
});

export default withHOC(
  connect(
    createStructuredSelector({
      orders: withClientId(profileOrdersById),
      currentScreen: currentScreen,
    }),
  ),
  withTranslation('screen.coachProfile.section.orderHistory'),
)(ProfileOrderHistorySection);
